import { useState } from 'react';
import { Form, Input, Select, Button, message, Tabs } from 'antd';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import ReactJson from '@microlink/react-json-view';
import { testApi } from '../services/api';
import { useLanguage } from '../contexts/LanguageContext';

const { TextArea } = Input;

const sectionStyle = {
  fontSize: 13,
  fontWeight: 600,
  color: '#1e293b',
  marginBottom: 12,
  paddingBottom: 6,
  borderBottom: '1px solid #f0f0f0',
};
const sectionStyleMt = { ...sectionStyle, marginTop: 8 };
const gridCol2 = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 };
const gridCol3 = { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 };

export default function RemitterManage() {
  const { t } = useLanguage();
  const [createForm] = Form.useForm();
  const [queryForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [queryLoading, setQueryLoading] = useState(false);
  const [createResult, setCreateResult] = useState(null);
  const [queryResult, setQueryResult] = useState(null);

  const handleCreate = async (values) => {
    setLoading(true);
    try {
      const requestBody = {
        requestId: 'req_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8),
        channelCode: values.channelCode,
        externalUserId: values.externalUserId,
        classification: values.classification,
        name: values.name,
        remitterId: values.remitterId || undefined,
        dateOfBirth: values.dateOfBirth || undefined,
        country: values.country || undefined,
        addressLine1: values.addressLine1 || undefined,
        addressLine2: values.addressLine2 || undefined,
        city: values.city || undefined,
        province: values.province || undefined,
        postalCode: values.postalCode || undefined,
        email: values.email || undefined,
        phone: values.phone || undefined,
        bankName: values.bankName || undefined,
        bankCode: values.bankCode || undefined,
        accountNumber: values.accountNumber || undefined,
        userType: values.userType || undefined,
        extParam: values.extParam || undefined,
      };
      var username = localStorage.getItem('username') || 'admin';
      var resp = await testApi.executeTest({
        testType: 'REMITTER_CREATE',
        channelCode: values.channelCode,
        businessPartner: values.businessPartner || 'test',
        currency: '',
        env: 'SANDBOX',
        executor: username,
        requestBody: JSON.stringify(requestBody),
      });
      var res = resp.data;
      if (res.data && res.data.responseBody && typeof res.data.responseBody === 'string') {
        try {
          res.data.responseBody = JSON.parse(res.data.responseBody);
        } catch (e) {
          // ignore parse error
        }
      }
      setCreateResult(res);
      if (res.data && res.data.success) {
        message.success('付款人创建成功');
      } else {
        var errMsg = (res.data && res.data.errorMessage) || res.msg || '未知错误';
        message.warning('创建失败: ' + errMsg);
      }
    } catch (error) {
      var msg = (error.response && error.response.data && error.response.data.msg) || error.message;
      message.error('创建失败: ' + msg);
      setCreateResult((error.response && error.response.data) || { error: error.message });
    } finally {
      setLoading(false);
    }
  };

  const handleQuery = async (values) => {
    setQueryLoading(true);
    try {
      const requestBody = {
        requestId: 'req_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8),
        remitterId: values.remitterId,
        channelCode: values.channelCode,
      };
      var resp = await testApi.executeTest({
        testType: 'REMITTER_QUERY',
        channelCode: values.channelCode || 'CORPAY',
        businessPartner: values.businessPartner || 'test',
        currency: '',
        env: 'SANDBOX',
        executor: localStorage.getItem('username') || 'admin',
        requestBody: JSON.stringify(requestBody),
      });
      var res = resp.data;
      if (res.data && res.data.responseBody && typeof res.data.responseBody === 'string') {
        try {
          res.data.responseBody = JSON.parse(res.data.responseBody);
        } catch (e) {
          // ignore parse error
        }
      }
      setQueryResult(res);
    } catch (error) {
      var msg = (error.response && error.response.data && error.response.data.msg) || error.message;
      message.error('查询失败: ' + msg);
      setQueryResult((error.response && error.response.data) || { error: error.message });
    } finally {
      setQueryLoading(false);
    }
  };

  const renderResultPanel = (result) => {
    if (result) {
      return (
        <div style={{ background: '#fff', borderRadius: 8, border: '1px solid #f0f0f0', padding: 20, minHeight: 300 }}>
          <ReactJson src={result} collapsed={1} theme="rjv-default" displayDataTypes={false} displayObjectSize={false} enableClipboard />
        </div>
      );
    }
    return (
      <div style={{ background: '#fff', borderRadius: 8, border: '1px solid #f0f0f0', padding: 20, minHeight: 300 }}>
        <div style={{ padding: 60, textAlign: 'center', color: '#9ca3af', background: '#f9fafb', borderRadius: 8, border: '2px dashed #e5e7eb' }}>
          <div style={{ marginTop: 12 }}>提交后显示结果</div>
        </div>
      </div>
    );
  };

  const createTab = (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
      <div style={{ background: '#fff', borderRadius: 8, border: '1px solid #f0f0f0', padding: 24 }}>
        <Form form={createForm} layout="vertical" onFinish={handleCreate} initialValues={{ channelCode: 'CORPAY', classification: 'individual', businessPartner: 'test' }}>
          <Form.Item name="businessPartner" hidden>
            <Input />
          </Form.Item>

          <div style={sectionStyle}>基本信息</div>
          <div style={gridCol2}>
            <Form.Item label="渠道 (channelCode)" name="channelCode" rules={[{ required: true }]}>
              <Select options={[{ label: 'CORPAY', value: 'CORPAY' }]} />
            </Form.Item>
            <Form.Item label="分类 (classification)" name="classification" rules={[{ required: true }]}>
              <Select options={[{ label: 'individual (个人)', value: 'individual' }, { label: 'corporation (企业)', value: 'corporation' }]} />
            </Form.Item>
          </div>
          <div style={gridCol2}>
            <Form.Item label="外部用户ID (externalUserId)" name="externalUserId" rules={[{ required: true }]}>
              <Input placeholder="user_001" style={{ fontFamily: 'monospace' }} />
            </Form.Item>
            <Form.Item label="付款人姓名/公司名 (name)" name="name" rules={[{ required: true }]}>
              <Input placeholder="John Doe / Acme Ltd" />
            </Form.Item>
          </div>
          <div style={gridCol2}>
            <Form.Item label="付款人ID (remitterId)" name="remitterId" tooltip="可选，不传则自动生成">
              <Input placeholder="可选，自动生成" style={{ fontFamily: 'monospace' }} />
            </Form.Item>
            <Form.Item label="出生日期 (dateOfBirth)" name="dateOfBirth" tooltip="个人必填 yyyy-MM-dd">
              <Input placeholder="1990-01-15" />
            </Form.Item>
          </div>

          <div style={sectionStyleMt}>地址信息</div>
          <div style={gridCol3}>
            <Form.Item label="国家 (country)" name="country" tooltip="ISO2">
              <Input placeholder="CA" maxLength={2} />
            </Form.Item>
            <Form.Item label="省/州 (province)" name="province">
              <Input placeholder="Ontario" />
            </Form.Item>
            <Form.Item label="城市 (city)" name="city">
              <Input placeholder="Toronto" />
            </Form.Item>
          </div>
          <div style={gridCol2}>
            <Form.Item label="地址行1 (addressLine1)" name="addressLine1">
              <Input placeholder="123 Main St" />
            </Form.Item>
            <Form.Item label="地址行2 (addressLine2)" name="addressLine2">
              <Input placeholder="Suite 100" />
            </Form.Item>
          </div>
          <Form.Item label="邮编 (postalCode)" name="postalCode" style={{ maxWidth: 200 }}>
            <Input placeholder="M5V 2T6" />
          </Form.Item>

          <div style={sectionStyleMt}>联系和银行信息</div>
          <div style={gridCol3}>
            <Form.Item label="邮箱 (email)" name="email">
              <Input placeholder="john@example.com" />
            </Form.Item>
            <Form.Item label="电话 (phone)" name="phone">
              <Input placeholder="+1234567890" />
            </Form.Item>
            <Form.Item label="用户类型 (userType)" name="userType">
              <Input placeholder="可选" />
            </Form.Item>
          </div>
          <div style={gridCol3}>
            <Form.Item label="银行名称 (bankName)" name="bankName">
              <Input placeholder="TD Bank" />
            </Form.Item>
            <Form.Item label="银行代码 (bankCode)" name="bankCode">
              <Input placeholder="TDOMCATTTOR" />
            </Form.Item>
            <Form.Item label="银行账号 (accountNumber)" name="accountNumber">
              <Input placeholder="1234567890" />
            </Form.Item>
          </div>

          <div style={sectionStyleMt}>扩展参数</div>
          <Form.Item name="extParam" tooltip="渠道特有扩展参数 JSON">
            <TextArea rows={3} placeholder='{"occupation": "Engineer", "relationshipToYourCompany": "employee"}' style={{ fontFamily: 'monospace', fontSize: 12 }} />
          </Form.Item>

          <Button type="primary" htmlType="submit" icon={<PlusOutlined />} loading={loading} size="large" block style={{ height: 44, marginTop: 12 }}>
            {loading ? '创建中...' : '创建付款人'}
          </Button>
        </Form>
      </div>
      <div>
        <div style={sectionStyle}>创建结果</div>
        {renderResultPanel(createResult)}
      </div>
    </div>
  );

  const queryTab = (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
      <div style={{ background: '#fff', borderRadius: 8, border: '1px solid #f0f0f0', padding: 24 }}>
        <Form form={queryForm} layout="vertical" onFinish={handleQuery} initialValues={{ channelCode: 'CORPAY', businessPartner: 'test' }}>
          <Form.Item name="businessPartner" hidden>
            <Input />
          </Form.Item>
          <div style={sectionStyle}>查询条件</div>
          <Form.Item label="渠道" name="channelCode" rules={[{ required: true }]}>
            <Select options={[{ label: 'CORPAY', value: 'CORPAY' }]} />
          </Form.Item>
          <Form.Item label="付款人ID (remitterId)" name="remitterId" rules={[{ required: true }]}>
            <Input placeholder="e.g. REM_xxx" style={{ fontFamily: 'monospace' }} />
          </Form.Item>
          <Button type="primary" htmlType="submit" icon={<SearchOutlined />} loading={queryLoading} size="large" block style={{ height: 44 }}>
            {queryLoading ? '查询中...' : '查询付款人'}
          </Button>
        </Form>
      </div>
      <div>
        <div style={sectionStyle}>查询结果</div>
        {renderResultPanel(queryResult)}
      </div>
    </div>
  );

  const tabItems = [
    {
      key: 'create',
      label: (<span><PlusOutlined /> 创建付款人</span>),
      children: createTab,
    },
    {
      key: 'query',
      label: (<span><SearchOutlined /> 查询付款人</span>),
      children: queryTab,
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ marginBottom: 16 }}>付款人管理 (Remitter)</h2>
      <Tabs items={tabItems} />
    </div>
  );
}
